
export const LOAD_TRANSACTION_SPLIT_TEMPLATES = 'LOAD_TRANSACTION_SPLIT_TEMPLATES'
export const RECEIVE_TRANSACTION_SPLIT_TEMPLATES = 'RECEIVE_TRANSACTION_SPLIT_TEMPLATES'


export function loadTransactionSplitTemplates () {
	return {
		type: LOAD_TRANSACTION_SPLIT_TEMPLATES
	}
}